import http from '../interceptors/Intercepter';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const retrieveClients = async (username) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.get('/api/client/viewAll', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveEligibleClients = async (username, studyAllowsCoEnrolment) => {
  try {
    const params = { username };

    const { data } = await http.post('/api/client/viewAll-eligible', studyAllowsCoEnrolment, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const createClient = async (username, clientVo) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/client/create', clientVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewClient = async (username, clientExternalReference) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/client/view', { clientExternalReference }, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateClient = async (username, clientVo) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/client/update', clientVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const linkClientToStudy = async (username, linkClientToStudyRequest) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/client/link-to-study', linkClientToStudyRequest, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const notifyClientCreationRequest = async (username, clientNotificationRequest) => {
  try {
    const params = {
      username: username,
    };

    const { data } = await http.post('/api/client/notify-user-of-client-creation', clientNotificationRequest, {
      params,
      ...config,
    });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const deleteRelation = async (username, relationExternalReference) => {
  try {
    const params = {
      username,
      relationExternalReference,
    };

    const { data } = await http.delete('/api/client/delete-relation', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
